module.exports = __webpack_public_path__ + "img/flutter.ba4ad90b.png";